/**
 * The compiled template an element type publishes, or `null`.
 *
 * `compiledTemplateJson` is typed `unknown` because its callers hold it in every degree of
 * certainty — a parsed {@link CompiledTemplateJson}, a `parseJsonBlob` result that may be
 * `null`, a structure record that may itself be missing — and narrowing it here means none
 * of them has to.
 */
export function resolveEntityTemplate(compiledTemplateJson, entityTypeKey) {
    if (!compiledTemplateJson || typeof compiledTemplateJson !== "object") {
        return null;
    }
    const templatesByEntityType = compiledTemplateJson
        .templatesByEntityType;
    if (!templatesByEntityType || typeof templatesByEntityType !== "object") {
        return null;
    }
    // Read through the own-property descriptor rather than by indexing: an element type named
    // `constructor` or `__proto__` would otherwise resolve to something off `Object.prototype`
    // and be treated as a published template.
    const template = Object.getOwnPropertyDescriptor(templatesByEntityType, entityTypeKey)?.value;
    if (!template || typeof template !== "object") {
        return null;
    }
    return template;
}
/** The template's tab with this `tabKey`, or `null` when the template publishes none. */
export function resolveEntityTemplateTab(template, tabKey) {
    const tabs = template?.tabs;
    if (!Array.isArray(tabs)) {
        return null;
    }
    return tabs.find((candidate) => candidate?.tabKey === tabKey) ?? null;
}
